module.exports = __webpack_public_path__ + "static/bg-wedding-de80750eee9af4db482899b055b5ea86.jpg";